import { PermissionNameUnionType } from '@api';
import { PermittedItemType } from '@common';
import { GeneralInformationTableRowType } from '../types';

export const generalInformationRows: (PermittedItemType<PermissionNameUnionType> &
  GeneralInformationTableRowType)[] = [
  { label: 'NAME', accessor: 'name', requiredPermissions: [] },
  { label: 'ABBREVIATION', accessor: 'abbreviation', requiredPermissions: [] },
  { label: 'WEBSITE', accessor: 'website', requiredPermissions: [] },
  { label: 'ARTIST_LINK', accessor: 'artistLink', requiredPermissions: [] },
  { label: 'GENRE', accessor: 'genre', requiredPermissions: [] },
  {
    label: 'IS_DOMESTIC_ARTIST',
    accessor: 'isDomesticArtist',
    requiredPermissions: [],
  },
  { label: 'IS_FEMALE_ACT', accessor: 'isFemaleAct', requiredPermissions: [] },
  { label: 'COMMENT', accessor: 'comment', requiredPermissions: [] },
  {
    label: 'ORGANIZATION_UNIT',
    accessor: 'defaultOrganizationUnit',
    requiredPermissions: [
      {
        permission: 'ORGANIZATION_UNIT',
        action: 'READ',
      },
    ],
  },
];
